import { RootState } from '..';

export const selectApiState = (state: RootState, key: string) => {
  return state.api[key];
};
